import * as React from 'react';
import { memo } from 'react';
import styled from 'styled-components';
import { Card } from '@mui/material';
import { Col, Divider, Row } from 'antd';
import { Link } from 'react-router-dom';
import { EventDataType } from '../../../../common/types';
import { colors, fonts } from '../../assets/constStyles';
import { paths } from '../../consts';

const CardStyled = styled(Card)`
  width: 100%;
  box-shadow: rgba(145, 158, 171, 0.3) 0 0 2px 0, rgba(145, 158, 171, 0.12) 0 12px 24px -4px;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  position: relative;
  padding: 30px;
  height: 100%;

  && * {
    font-family: ${fonts.font2} !important;
  }
`;
export const StyledRow = styled(Row)`
  padding: 8px 0;
`;

export const YearTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: ${colors.colorTextDark};
  margin: 0;
`;

export const AwardsLabel = styled.span`
  font-size: 18px;
  font-weight: 400;
  color: #888;
  margin-left: 6px;
`;

export const EventNumber = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: ${colors.colorRed};

  sup {
    font-size: 10px;
    vertical-align: super;
    margin-left: 1px;
  }
`;

export const StyledDivider = styled(Divider)`
  height: 40px;
  border-inline-start-color: #c0c0c0;
  margin: 0 12px;
`;

// const NameStyled = styled.p`
//   display: -webkit-box;
//   -webkit-box-orient: vertical;
//   overflow: hidden;
//   -webkit-line-clamp: 2;
//   font-weight: 400;
//   min-height: 52px;
//   text-transform: uppercase;
// `;

interface IEventCardItem {
  dataCard: EventDataType,
}

const EventCardItem: React.FC<IEventCardItem> = ({ dataCard }) => (
    <Col xs={24} sm={8} md={8} lg={6} xl={6}>
        <Link to={`${paths.EVENTS}/${dataCard.year}`}>
            <CardStyled>
                <StyledRow align="middle" justify="space-between">
                    <Col flex="auto">
                        <YearTitle>
                            {dataCard.year} <AwardsLabel>Awards</AwardsLabel>
                        </YearTitle>
                    </Col>

                    <StyledDivider type="vertical" />

                    <Col>
                        <EventNumber>
                            {dataCard.num}
                            <sup>th</sup>
                        </EventNumber>
                    </Col>
                </StyledRow>
            </CardStyled>
        </Link>
    </Col>
);

export default memo(EventCardItem);
